export default __webpack_public_path__ + "static/media/ezgif.com-gif-maker.dcc96d10.png";